import React, {useCallback, useState} from 'react';
import Radio from "../../../../components/style-guide/form/radio/Radio";
import clsx from "clsx";
import styles from './FilterBar.module.scss';
import {fetchReportsByCreatorAction} from "../../store/my-reports.actions";
import {connect} from "react-redux";

export const FilterBar = ({actions}) => {
  const [filterBy, setFilter] = useState('ALL');

  const updateFilter = useCallback((filter) => {
    setFilter(filter);
    actions.fetchReportsByCreator(filter);
  }, [setFilter]);

  return (
    <div className={clsx('pl-4 text-left w-100 pb-3 flex', styles.filterBarContainer)}>
      <Radio
        name="radio"
        id="radio1"
        value="ALL"
        label="Todos"
        checked={filterBy === 'ALL'}
        onChange={e => updateFilter('ALL')}/>

      <Radio
        name="radio"
        id="radio2"
        value="REPORT_REQUEST_BY_ME"
        label="Solicitados por mí"
        checked={filterBy === 'REPORT_REQUEST_BY_ME'}
        onChange={e => updateFilter('REPORT_REQUEST_BY_ME')}/>

      <Radio
        name="radio"
        id="radio3"
        value="MY_REPORT_REQUEST"
        label="Solicitados para mí"
        checked={filterBy === 'MY_REPORT_REQUEST'}
        onChange={e => updateFilter('MY_REPORT_REQUEST')}/>
    </div>
  );
};

FilterBar.propTypes = {}

FilterBar.defaultProps = {}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      fetchReportsByCreator: (payload) => dispatch(fetchReportsByCreatorAction(payload)),
    },
    dispatch
  }
};

export default connect(
  null,
  mapDispatchToProps
)(React.memo(FilterBar));
